/*
 *  -----------------------------------------------------------------------
 *    <copyright file="logout.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import Settings from 'settings/settings';
import Log from 'utils/logger';

export default async (token: string) => {
    Log.debug(`Performing Azure logout: ${token}`);
    let errorMessage = null;

    const response = await fetch(`${Settings.api.url()}/api/logout`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    }).catch((error) => {
        Log.error(`Exception logout in with Azure token: ${error.message}`);
        errorMessage = error.message;
    });

    if (errorMessage || !response) return { error: errorMessage };

    try {
        return await response.json();
    } catch (error: any) {
        return { error: error.message };
    }
};
